// 장바구니 드로어 기능
document.addEventListener("DOMContentLoaded", function () {
    // 장바구니 드로어 요소
    const cartDrawer = document.getElementById("cart-drawer");
    const closeCartDrawerButton = document.querySelector(".cart-drawer-close");
    const proceedToCheckoutButton = document.getElementById(
        "proceed-to-checkout"
    );
    const loadingOverlay = document.getElementById("loading-overlay");

    // 장바구니 오버레이 생성
    const cartOverlay = document.createElement("div");
    cartOverlay.className = "cart-drawer-overlay";
    document.body.appendChild(cartOverlay);

    // 장바구니 드로어 콘텐츠 업데이트
    window.showCartDrawer = function () {
        document.body.classList.remove("show-mobile-menu");
        document.body.classList.remove("show-mobile-search");

        fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
                // 장바구니 드로어 업데이트 및 표시
                viewCartDrawer(cart);
            })
            .catch((error) => {
                console.error("장바구니 정보 가져오기 오류:", error);
            });
    };

    // 장바구니 아이템 렌더링
    function renderCartItems(cart) {
        const cartItemsContainer = document.querySelector(".cart-drawer-items");
        const subtotalValue = document.querySelector(
            ".cart-drawer-subtotal-value"
        );

        if (!cartItemsContainer || !subtotalValue) return;

        // 합계 업데이트
        subtotalValue.innerHTML =
            '<span class="money">' + formatMoney(cart.total_price) + "</span>";

        // 아이템이 없는 경우
        if (cart.item_count === 0) {
            cartItemsContainer.innerHTML =
                '<div class="cart-drawer-empty"><p>YOUR CART IS EMPTY</p></div>';
            return;
        }

        // 아이템 목록 생성
        let itemsHTML = "";
        cart.items.forEach((item, index) => {
            const lineIndex = index + 1;
            const itemImage = item.image;

            // 변형 옵션 처리
            let variantHTML = "";
            if (item.variant_title && item.variant_title !== "Default Title") {
                const variantOptions = item.variant_title.split(" / ");
                const optionNames = item.options_with_values
                    ? item.options_with_values.map((opt) => opt.name)
                    : [];

                variantHTML = `<div class="cart-drawer-item-variant">`;

                for (let i = 0; i < variantOptions.length; i++) {
                    // 옵션 이름이 있으면 이름과 값을 함께 표시, 없으면 값만 표시
                    if (optionNames[i]) {
                        variantHTML += `<div>${optionNames[i]}: ${variantOptions[i]}</div>`;
                    } else {
                        variantHTML += `<div>${variantOptions[i]}</div>`;
                    }
                }

                variantHTML += `</div>`;
            }

            itemsHTML += `
            <div class="cart-drawer-item" data-variant-id="${item.variant_id}">
                <div class="cart-drawer-item-image">
                <img src="${itemImage}" alt="${
                item.title
            }" width="200" height="290">
                </div>
                <div class="cart-drawer-item-info">
                <div class="cart-drawer-item-title-wrap">
                    <div class="cart-drawer-item-title">${
                        item.product_title
                    }</div>
                    <div class="cart-drawer-item-amount">
                      <span class="money">${formatMoney(item.price)}</span>
                    </div>
                </div>

                ${variantHTML}

                <div class="cart-drawer-item-quantity">
                    <div class="cart-drawer-item-quantity-label">Quantity: </div>
                    <div class="cart-drawer-item-quantity-controls">
                    <button class="quantity-decrease" data-line="${lineIndex}" data-quantity="${
                item.quantity - 1
            }">-</button>
                    <span class="cart-drawer-item-quantity">${
                        item.quantity
                    }</span>
                    <button class="quantity-increase" data-line="${lineIndex}" data-quantity="${
                item.quantity + 1
            }">+</button>
                    </div>
                </div>

                <a href="/cart/change?line=${lineIndex}&quantity=0" class="cart-drawer-item-remove" data-line="${lineIndex}">REMOVE ITEM</a>
                </div>
            </div>
            `;
        });

        cartItemsContainer.innerHTML = itemsHTML;

        // 수량 증가/감소 버튼 이벤트 리스너 추가
        document
            .querySelectorAll(".quantity-increase, .quantity-decrease")
            .forEach((button) => {
                button.addEventListener("click", function (e) {
                    e.preventDefault();
                    const line = this.dataset.line;
                    const quantity = parseInt(this.dataset.quantity);
                    const currentQuantity = parseInt(
                        this.parentElement.querySelector(
                            ".cart-drawer-item-quantity"
                        ).textContent
                    );

                    // 수량이 1에서 0으로 변경될 경우 확인 메시지 표시
                    if (currentQuantity === 1 && quantity === 0) {
                        if (
                            confirm(
                                "Are you sure you want to remove this item from your cart?"
                            )
                        ) {
                            updateCartItemQuantity(line, quantity);
                        }
                    }
                    // 그 외의 경우 바로 수량 업데이트
                    else if (quantity >= 0) {
                        updateCartItemQuantity(line, quantity);
                    }
                });
            });

        // 장바구니 아이템 수량 업데이트 함수
        function updateCartItemQuantity(line, quantity) {
            // 로딩 오버레이 표시
            loadingOverlay.classList.add("active");

            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    line: line,
                    quantity: quantity,
                }),
            })
                .then((response) => response.json())
                .then((cart) => {
                    renderCartItems(cart);
                    // 로딩 오버레이 숨기기
                    loadingOverlay.classList.remove("active");
                })
                .catch((error) => {
                    console.error("장바구니 수량 업데이트 오류:", error);
                    // 오류 발생 시에도 로딩 오버레이 숨기기
                    loadingOverlay.classList.remove("active");
                });
        }

        // 삭제 버튼 이벤트 리스너 추가
        document
            .querySelectorAll(".cart-drawer-item-remove")
            .forEach((button) => {
                button.addEventListener("click", function (e) {
                    e.preventDefault();
                    const line = this.dataset.line;
                    removeCartItem(line);
                });
            });

        if (window.bucksCC) {
            window.bucksCC.reConvert();
        }
    }

    // 장바구니 아이템 삭제
    function removeCartItem(line) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                line: line,
                quantity: 0,
            }),
        })
            .then((response) => response.json())
            .then((cart) => {
                renderCartItems(cart);
            })
            .catch((error) => {
                console.error("장바구니 아이템 삭제 오류:", error);
            });
    }

    // 장바구니 드로어 표시
    window.viewCartDrawer = function (cart) {
        if (cart) {
            renderCartItems(cart);
        }

        cartDrawer.classList.add("active");
        cartOverlay.classList.add("active");
        document.body.classList.add("no-scroll");
    };

    // 장바구니 드로어 숨기기
    window.hideCartDrawer = function () {
        cartDrawer.classList.remove("active");
        cartOverlay.classList.remove("active");
        document.body.classList.remove("no-scroll");
    };

    // 결제 진행 및 로딩 표시
    function proceedToCheckout() {
        document.body.classList.add("show-checkout-overlay");

        // 1초 후 결제 페이지로 이동
        setTimeout(() => {
            window.location.href = "/checkout";
        }, 1000);
    }

    if (closeCartDrawerButton) {
        closeCartDrawerButton.addEventListener("click", hideCartDrawer);
    }

    cartOverlay.addEventListener("click", hideCartDrawer);

    if (proceedToCheckoutButton) {
        proceedToCheckoutButton.addEventListener("click", proceedToCheckout);
    }

    // 장바구니 버튼 클릭 시 장바구니 열기
    const bagButton = document.querySelector(".nav-item.nav-bag");
    if (bagButton) {
        bagButton.addEventListener("click", function (e) {
            e.preventDefault();
            if (cartDrawer.classList.contains("active")) {
                window.hideCartDrawer();
            } else {
                window.showCartDrawer();
            }
        });
    }

    // ESC 키로 장바구니 닫기
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            hideCartDrawer();
        }
    });
});

// 페이지 이동 시 show-checkout-overlay 클래스 제거
// 다른 웹사이트 또는 페이지로 이동 시 show-checkout-overlay 클래스 제거
window.addEventListener("unload", function () {
    console.log("unload");
    document.body.classList.remove("show-checkout-overlay");
});
